import { optionCategory_Calendar } from './category.locstring.json';
import accountsSubCategory from './accountsSubCategory';
import agendaMailSubCategory from './agendaMailSubCategory';
import availabilitySubCategory from './availabilitySubCategory';
import customizeActionsSubCategory from './customizeActionsSubCategory';
import eventsAndInvitationsSubCategory from './eventsAndInvitationsSubCategory';
import eventsFromEmailSubCategory from './eventsFromEmailSubCategory';
import pbpSubCategory from './pbpSubCategory';
import resourceSchedulingSubCategory from './resourceSchedulingSubCategory';
import sharedCalendarsSubCategory from './sharedCalendarsSubCategory';
import viewSubCategory from './viewSubCategory';
import weatherSubCategory from './weatherSubCategory';
import roomPreferencesSubCategory from './roomPreferencesSubCategory';
import { ControlIcons } from 'owa-control-icons';
import { OptionCategory } from 'owa-options-core';

let calendarCategory: OptionCategory = {
    key: 'calendar',
    titleStringKey: optionCategory_Calendar,
    icon: ControlIcons.Calendar,
    subcategories: [
        viewSubCategory,
        eventsAndInvitationsSubCategory,
        weatherSubCategory,
        eventsFromEmailSubCategory,
        agendaMailSubCategory,
        sharedCalendarsSubCategory,
        customizeActionsSubCategory,
        pbpSubCategory,
        availabilitySubCategory,
        accountsSubCategory,
        resourceSchedulingSubCategory,
        roomPreferencesSubCategory,
    ],
};

export default calendarCategory;
